(function($){
$(document).ready(function() {

    function initDatatables(){
      $('.datatabled').each(function() {
          let _scrollY = $(this).data('scrolly') === undefined ? 400 : $(this).data('scrolly');
          $(this).DataTable({
              destroy: true,
              scrollY: _scrollY
          });
      }).addClass('hover stripe display');
    }
    initDatatables();

    // $(window).on('resize', initDatatables);
    $("#toggle-col-infos").on('change', initDatatables);

    let adress = [],
        postcode = [],
        citycode = [],
        city = [],
        autoCompleteJS = [],
        champsAdress = [],
        idsRecherche = [];

    var all = $('.adresseAutoComplete');
    // console.log(all);

    all.each(function(i) {
        item = $(this);
        myobject = [];
        champsAdress[i] = item.find('.autoComplete');
        idsRecherche[i] = "#"+champsAdress[i].attr('id');
        adress[i] = item.find('.adress');
        postcode[i] = item.find('.postcode');
        citycode[i] = item.find('.citycode');
        city[i] = item.find('.city');
        autoCompleteJS[i] = new autoComplete({
            selector: idsRecherche[i],
            placeHolder: "Recherche adresse...",
            data: {
                src: async () => {

                   let term = champsAdress[i].val();
                   // console.log(term);
                   if (term.length>3) {
                     let response = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${term}`)
                     let json = await response.json();
                     myobject = json.features.map(function(el) {
                        return {
                          label: el.properties.label,
                          value: el.properties.label,
                          lat: el.geometry.coordinates[1],
                          lon: el.geometry.coordinates[0],
                          housenumber: el.properties.housenumber,
                          name: el.properties.name,
                          postcode: el.properties.postcode,
                          citycode: el.properties.citycode,
                          city: el.properties.city,
                          context: el.properties.context,
                          type: el.properties.type,
                          street: el.properties.street,
                          boundingbox: null
                        }
                      })
                      adresses = myobject.map(el => el.value)
                      //console.log(adresses);
                   } else {
                     adresses = []

                      postcode[i].val('')
                      citycode[i].val('')
                      city[i].val('')
                      // lon[i].val('')
                      // lat[i].val('')
                   }
                  return adresses
                },
                cache: false,
            },
            resultsList: {
                element: (list, data) => {
                    if (!data.results.length) {
                        // Create "No Results" message element
                        let message = document.createElement("div");
                        // Add class to the created element
                        message.setAttribute("class", "no_result");
                        // Add message text content
                        message.innerHTML = `<span>Aucune adresse trouvée pour : "${data.query}"</span>`;
                        // Append message element to the results list
                        list.prepend(message);
                        postcode[i].val('');
                        citycode[i].val('');
                        city[i].val('');
                        // lon[i].val('');
                        // lat[i].val('');
                    }
                },
                noResults: true,
            },
            resultItem: {
                highlight: true
            },
            events: {
                input: {
                    selection: (event) => {
                        let selection = event.detail.selection.value;
                        autoCompleteJS[i].input.value = selection;
                        var result = myobject.find(el => el.value == event.detail.selection.value)
                        if (result) {
                          //autoCompleteJS[i].input.value = result.name;
                          adress[i].val(result.name)
                          postcode[i].val(result.postcode);
                          citycode[i].val(result.citycode);
                          city[i].val(result.city);
                          // lon[i].val(result.lon);
                          // lat[i].val(result.lat);
                        } else {
                          adress[i].val('')
                          postcode[i].val('');
                          citycode[i].val('');
                          city[i].val('');
                          // lon[i].val('');
                          // lat[i].val('');
                        }

                    }
                }
            }
        });
    });

    if (message_popin != "")
        ouvre_popin(message_popin);

    $.datepicker.regional['fr'] = {
        closeText:       'Fermer',
        prevText:        'Précédent',
        nextText:        'Suivant',
        currentText:     'Courant',
        monthNames:      ['Janvier','Février','Mars','Avril','Mai','Juin', 'Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
        monthNamesShort: ['Jan','Fév','Mar','Avr','Mai','Jun', 'Jul','Aoû','Sep','Oct','Nov','Déc'],
        dayNames:        ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
        dayNamesShort:   ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
        dayNamesMin:     ['Di','Lu','Ma','Me','Je','Ve','Sa'],
        dateFormat:      'dd/mm/yy',
        firstDay: 1,
        isRTL: false
    };
    $.datepicker.setDefaults($.datepicker.regional['fr']);
    $.datepicker.setDefaults({
        showAnim: "slide",
        dateFormat: "dd/mm/yy",
        changeYear: true,
        onClose: function(){$(this).trigger("blur")}
    });
    $(".inputdate:not([readonly])").datepicker();

    $('form:not(.sure)').areYouSure();
    $('textarea[auto-grow]').autoGrow();

    $("#btn_retour_commission").on('click', function(e){
        window.location.href=$(this).data("urlcommission");
    });


    $("body").on('click', ".MEMBRE #type_Representant", function(e){
      //alert('ici');
        fiche = $(this).closest( ".MEMBRE" );
        fiche.find('.infos-representant').show();
        fiche.find(".fl-hab_membre-email input").data("required","1");
        fiche.find(".fl-email input").data("required","1");
        fiche.find(".type-du-membre").html("Representant");
        fiche.find(".fiche_membres").addClass('fiche_representants');
    });

    $("body").on('click', ".MEMBRE #type_Membre", function(e){
        fiche = $(this).closest( ".MEMBRE" );
        fiche.find('.infos-representant').hide();
        fiche.find(".fl-hab_membre-email input").data("required",null);
        fiche.find(".fl-email input").data("required",null);
        fiche.find(".type-du-membre").html("Membre");
        fiche.find(".fiche_membres").removeClass('fiche_representants');
    });

    $("body").on('click', "#subventions_Oui", function(e){
      //alert('ici');
        $('.infos-subventions').show();
    });

    $("body").on('click', "#subventions_Non", function(e){
      //alert('ici');
        $('.infos-subventions').hide();
    });


    $(".ajout-dept-rd").on('click', function(e){
        e.preventDefault();
        dernier = $('.selectdep p:last-child');
        dernier.clone(true).insertAfter(dernier);
    });

    $(".lien-ressource").on('click', function(e){
        e.preventDefault();
        var id  = $(this).data('ressource'),
            url = $(this).data('url');
          $.ajax({
            url: 'inc/xhr/actions.php?action=lien_ressource&id='+id,
            success: function(data) {
              window.open(url);
            }
        });

    });

    $(".voir-video").on('click', function(e){
        e.preventDefault();
        var id = $(this).data('video');

          $.ajax({
            url: 'inc/xhr/actions.php?action=afficher_video&id='+id,
            success: function(data) {
              ouvre_popin(data);
            }
        });

    });

    $(".popin-contrib").on('click', function(e){
        e.preventDefault();
        var id = $(this).data('idc');
        var type = $(this).data('typec');

          $.ajax({
            url: 'inc/xhr/actions.php?action=popin_contrib&id='+id+'&type='+type,
            success: function(data) {
              ouvre_popin(data);
            }
        });

    });



    $(".formcreacompteja select[name='dept']").on('change', function(e){

        var dpt = $(this).val();

          $.ajax({
            url: 'inc/xhr/actions.php?action=getBanquesFromDpt&dpt='+dpt,
            success: function(data) {
              $(".formcreacompteja select[name='bnq_id']").replaceWith(data);
            }
        });

    });


    $(".confirmer-acc").on('click', function(e){
        e.preventDefault();
        var conf = $(this).data('conf');
        var hab = $(this).data('hab');
        var acc = $(this).data('acc');
        if(conf == 'oui') {
            $.ajax({
              url: 'inc/xhr/actions.php?action=confirmer_acc&hab='+hab+'&acc='+acc,
              success: function(data) {
                ouvre_popin(data);
              }
          });

        } else if(conf == 'non') {
            $.ajax({
              url: 'inc/xhr/actions.php?action=refuser_acc&hab='+hab+'&acc='+acc,
              success: function(data) {
                ouvre_popin(data);
              }
          });
        }
    });


    $(".AfficheFormFaq").on('click', function(e){
        e.preventDefault();
        var id_faq = $(this).data('idfaq');
        $.ajax({
          url: 'inc/xhr/actions.php?action=formulaire_faq&id_faq='+id_faq,
          success: function(data) {
            ouvre_popin(data);
          }
      });
    });

    $(".AfficheFormAssur").on('click', function(e){
        var id_hab = $(this).data('idhab');
        var id_ja = $(this).data('idja');
        var saison = $(this).data('saison');
        var id_assur = $(this).data('idassur');
        $.ajax({
          url: 'inc/xhr/actions.php?action=formulaire_assurance&hab_id='+id_hab+'&ja_id='+id_ja+'&id_assur='+id_assur+'&saison='+saison,
          success: function(data) {
            ouvre_popin(data);
          }
      });
    });


    $(".MonterFaq").on('click', function(e){
        e.preventDefault();
        var id_faq = $(this).data('idfaq');
          $.ajax({
              url: 'inc/xhr/actions.php?action=monter_faq&id_faq='+id_faq,
              success: function(data) {
                //console.log(data);
                window.location.reload(true);
              }
          });

    });

    $(".SuppFaq").on('click', function(e){
        e.preventDefault();
        var id_faq = $(this).data('idfaq');
        if(confirm("Etes-vous sûr(e) de vouloir supprimer cette question ? ")) {
          $.ajax({
              url: 'inc/xhr/actions.php?action=supprimer_faq&id_faq='+id_faq,
              success: function(data) {
                //console.log(data);
                window.location.reload(true);
              }
          });
        }
    });

    $(".SuppFaq").on('click', function(e){
        e.preventDefault();
        var id_faq = $(this).data('idfaq');
        if(confirm("Etes-vous sûr(e) de vouloir supprimer cette question ? ")) {
          $.ajax({
              url: 'inc/xhr/actions.php?action=supprimer_faq&id_faq='+id_faq,
              success: function(data) {
                //console.log(data);
                window.location.reload(true);
              }
          });
        }
    });

    $(".fermeture_compte_bancaire").on('click', function(e){
        e.preventDefault();
        if(confirm("Etes-vous sûr(e) de vouloir lancer la procédure de cloture de ce compte ? En confirmant, vous n'aurez plus accès à ce compte. Vous pourrez si vous le souhaitez lancer une nouvelle procédure d'ouverture de compte.")) {
          $.ajax({
              url: 'inc/xhr/actions.php?action=enregistrer_statut&type=banque&id_statut=51',
              success: function(data) {
                //console.log(data);
                window.location.reload(true);
              }
          });
        }
    });

    $("#activite_n_zero").on('change', function(e){
        var menu = $(this);
        id_activite = menu.val();
        if(id_activite=="") {
          $("#span_libele_n_un").html("");
          $("#span_activite_n_un").html("");
        } else {
          $.ajax({
              url: 'inc/xhr/actions.php?action=get_activite_n_un&id_activite='+id_activite,
              success: function(data) {
                $("#span_libele_n_un").html("Détail");
                $("#span_activite_n_un").html(data);
              }
          });
        }
    });

    $("body").on('change', ".typoAcc", function(e){
        e.preventDefault();
        var menu = $(this);
        var div = menu.parents('.Typoacc').first();
        var nextniveau = menu.data('niveau')+1;
        var niveau1 = menu.data('niveau1');
        var indice = menu.data('indice');
        var val = menu.val();
        $.ajax({
            url: 'inc/xhr/actions.php?action=affiche_menu_typo_acc&niveau1='+niveau1+'&val='+val+'&indice='+indice,
            success: function(data) {
                // console.log(".niveau"+nextniveau+"acc");
                div.find(".niveau"+nextniveau+"acc").html(data);
                if(menu.data('niveau')==1)
                   div.find(".niveau3acc").html("");
            }
        });
    });

    $("body").on('click', ".rehab_automatique", function(e){
        e.preventDefault();
        docid = $(this).data('habid');
        value = $(this).data('value');
          $.ajax({
              url: 'inc/xhr/actions.php?action=rehab_automatique&habid='+docid+'&value='+value,
              success: function(data) {
                //console.log(data);
                window.location.reload(true);
              }
          });


    });

    $("body").on('click', ".supprimer-document", function(e){
        e.preventDefault();
        docid = $(this).data('docid');
        if(confirm("Supprimer le document ?")) {
          $.ajax({
              url: 'inc/xhr/actions.php?action=supp_document&docid='+docid,
              success: function(data) {
                //console.log(data);
                window.location.reload(true);
              }
          });
        }

    });

    $("body").on('click', ".modifier-document", function(e){
        e.preventDefault();
        docid = $(this).data('docid');
        // console.log(docid);
          $.ajax({
              url: 'inc/xhr/actions.php?action=form_document&docid='+docid,
              success: function(data) {
                  ouvre_popin(data);
              }
          });

    });


    $("body").on('click', ".ajouter-document", function(e){
        e.preventDefault();
        habid = $(this).data('habid');
        jaid = $(this).data('jaid');
        cptid = $(this).data('cptid');
        assid = $(this).data('assid');
          $.ajax({
              url: 'inc/xhr/actions.php?action=form_document&jaid='+jaid+'&habid='+habid+'&cptid='+cptid+'&assid='+assid,
              success: function(data) {
                  ouvre_popin(data);
              }
          });

    });

    $("body").on('click', ".ajout_commisssion", function(e){
        e.preventDefault();

          $.ajax({
              url: 'inc/xhr/actions.php?action=ajout_commisssion',
              success: function(data) {
                  ouvre_popin(data);
              }
          });

    });

    $("body").on('click', ".ajout-relais-commision", function(e){
        e.preventDefault();
        var date = $(this).data('date');

          $.ajax({
              url: 'inc/xhr/actions.php?action=ajout_relais_commision&date='+date,
              success: function(data) {
                  ouvre_popin(data);
              }
          });

    });

    $("body").on('click', ".ajout-jeunes-commision", function(e){
        e.preventDefault();
        var date = $(this).data('date');

          $.ajax({
              url: 'inc/xhr/actions.php?action=ajout_jeunes_commision&date='+date,
              success: function(data) {
                  ouvre_popin(data);
              }
          });

    });

    $("body").on('click', ".ja-membre-com", function(e){
        e.preventDefault();
        var id = $(this).data('comid');
        var date = $(this).data('date');

          $.ajax({
              url: 'inc/xhr/actions.php?action=modif_ja_membre_comm&id='+id,
              success: function(data) {
                  ouvre_popin(data);
              }
          });

    });




    $("body").on('click', ".supp-rd-com", function(e){
        e.preventDefault();
        var id = $(this).data('comid');
        if(confirm("Etes-vous sûr de vouloir supprimer ce RD pour cette commission ?")) {
          $.ajax({
              url: 'inc/xhr/actions.php?action=supprimer&objet=rnja_membres_commissions&id='+id,
              success: function(data) {
                  if(data=="")
                    $("#ligne"+id).remove();
              }
          });
        }
    });



    $("body").on('click', ".supp-jeune-com", function(e){
        e.preventDefault();
        var id = $(this).data('comid');
        // console.log('id : ' + id);
        if(confirm("Etes-vous sûr de vouloir supprimer ce Jeune pour cette commission ?")) {
          $.ajax({
              url: 'inc/xhr/actions.php?action=supprimer&objet=rnja_membres_commissions&id='+id,
              success: function(data) {
                  if(data=="")
                    $("#ligneJ"+id).remove();
              }
          });
        }
    });


    $("body").on('click', ".supp", function(e){
        e.preventDefault();
        var id = $(this).data('id');
        var objet = $(this).data('objet');
        comp_alerte = " cette ligne ?";
        if(objet=="rnja_habilitation")
          comp_alerte = " cette demande d'habilitation ?";
        if(confirm("Etes-vous sûr de vouloir supprimer"+comp_alerte)) {
          $.ajax({
              url: 'inc/xhr/actions.php?action=supprimer&objet='+objet+'&id='+id,
              success: function(data) {
                  if(data=="")
                    $("#ligne"+id).remove();
                  else{
                    // console.log(data);
                  }
              }
          });
        }
    });

    $("body").on('change', ".typoCont", function(e){
        e.preventDefault();
        var menu = $(this);
        var nextniveau = menu.data('niveau')+1;
        var niveau1 = menu.data('niveau1');
        var precisez = menu.data('precisez');
        var val = menu.val();
        $.ajax({
            url: 'inc/xhr/actions.php?action=affiche_menu_contexte_crea&niveau1='+niveau1+'&val='+val+'&precisez='+precisez,
            success: function(data) {
                $(".niveau"+nextniveau+"cont").html(data);
                if(menu.data('niveau')==1)
                  $(".niveau3cont").html("");
            }
        });
    });

    $(".cocheselectiontout").on('click', function(e){
        var checkbox = $(this);
        $(".cocheafficher").prop("checked", false);
        iscoche = checkbox.is(':checked');
        tablename=checkbox.data("tablename");
        $table = $("#"+tablename);
        $("#"+tablename+" .cocheselection").prop('checked', iscoche);
        if(iscoche) {
          lesid = new Array();
          $("#"+tablename+" .cocheselection").each(function (index, value){
              lesid.push($(this).data("id"));
              $(this).parent().parent().show();
          });
          $.ajax({
              url: 'inc/xhr/actions.php?action=selectioner_tout&tablename='+tablename+'&lesid='+lesid,
              success: function(data) {
                check_select_table(tablename);
              }
          });
        } else {
          $.ajax({
              url: 'inc/xhr/actions.php?action=vider_selection&tablename='+tablename,
              success: function(data) {
                check_select_table(tablename);
              }
          });
        }
    });

    $(".reset-form").on('click', function(e){
          search = $(this).data("form");
          $.ajax({
              url: 'inc/xhr/actions.php?action=reset_search&search='+search,
              success: function(data) {
                window.location.reload(true);
              }
          });
    });

    $(".demande_ouverture_compte").on('click', function(e){
        if(confirm('souhaitez-vous démarrer la procédure de demande d\'ouverture d\'un compte bancaire ?')) {
          $.ajax({
              url: 'inc/xhr/actions.php?action=demande_ouverture_compte',
              success: function(data) {
                //console.log(data);
                window.location.reload(true);
              }
          });
        }
    });

    $(".demande_ouverture_cfp").on('click', function(e){
        if(confirm('souhaitez-vous démarrer la procédure de demande d\'ouverture d\'une campagne de financement participatif ?')) {
          $.ajax({
              url: 'inc/xhr/actions.php?action=demande_ouverture_cfp',
              success: function(data) {
                //console.log(data);
                window.location.href(true);
              }
          });
        }
    });

    $(".creation-habilitation").on('click', function(e){
        type = $(this).data('type');
        comp_type = '';
        if(type != 'Réhabilitation')
          comp_type = ' en JA MAJEUR';
        if(confirm('souhaitez-vous démarrer la procédure de demande de ré-habilitation'+comp_type+' ?')) {
          $.ajax({
              url: 'inc/xhr/actions.php?action=creer_habilitation&type='+type,
              success: function(data) {
                window.location.reload(true);
              }
          });

        }
    });

    $(".cocheafficher").on('click', function(e){
        var checkbox = $(this);
        iscoche = checkbox.is(':checked');
        tablename=checkbox.data("tablename");
        $table = $("#"+tablename);
        if(iscoche) {
          $("#"+tablename+" .cocheselection").each(function (index, value){
              if(!$(this).is(':checked'))
                $(this).parent().parent().hide();
          });
        } else {
          $("#"+tablename+" .cocheselection").each(function (index, value){
              $(this).parent().parent().show();
          });
        }
    });

    $(".cocheselection").on('click', function(e){
        var checkbox = $(this);
        tablename=$(this).parents("table").attr('id');
        id =checkbox.data("id");
        $.ajax({
            url: 'inc/xhr/actions.php?action=cocheselection&tablename='+tablename+'&id='+id,
            success: function(data) {
              check_select_table(tablename);
            }
        });
    });

    $(".afficher-div").on('change', function(e){
        var val = $(this).val();
        var valForDisplay = $(this).data('afficher-val');
        var divToDisplay = $(this).data('afficher-div');
        if(val==valForDisplay)
          $('.'+divToDisplay).show();
        else
          $('.'+divToDisplay).hide();
    });

    $(".form_cheque").on('click', function(e){
        e.preventDefault();
        var table = $(this).data('table');
        $.ajax({
            url: 'inc/xhr/actions.php?action=form_cheque&table='+table,
            success: function(data) {
              ouvre_popin(data);
            }
        })
    });

    $(".btn_enregistrer_statut").on('click', function(e){
        e.preventDefault();
        var bouton = $(this);
        id_ref=bouton.data("id-ref");
        type=bouton.data("type");
        commentaire=bouton.data("commentaire");
        id_statut=bouton.data("id-statut");
        if(commentaire==1) {
          $.ajax({
              url: 'inc/xhr/actions.php?action=commentaire_statut&type='+type+'&id_ref='+id_ref+'&id_statut='+id_statut,
              success: function(data) {
                ouvre_popin(data)
              }
          })
        } else {
          $.ajax({
              url: 'inc/xhr/actions.php?action=enregistrer_statut&type='+type+'&id_ref='+id_ref+'&id_statut='+id_statut,
              success: function(data) {
                //ouvre_popin(data)
                location.reload();
              }
          })
        }
    });

    $(".btn_annuler_statut").on('click', function(e){
        e.preventDefault();
        var bouton = $(this);
        item_id=bouton.data("id-ref");
        id_statut=bouton.data("id-statut");
        id_etape=bouton.data("id-etape");
        type=bouton.data("type");
        $.ajax({
            url: 'inc/xhr/actions.php?action=annuler_statut&type='+type+'&item_id='+item_id+'&id_statut='+id_statut+'&id_etape='+id_etape,
            success: function(data) {
              location.reload();
            }
        })
    });

    $(".ajout-fiche").on('click', function(e){
        //e.preventDefault();
        var bouton = $(this);
        num = $(".fiche_membres").length+1;
        $.ajax({
            url: 'inc/xhr/actions.php?action=ajouter_membre&num='+num,
            success: function(data) {
                bouton.before(data);
                $(".inputdate").datepicker();
            }
        })
    });

    // Accompagnateur 1

    $("#has_acc_Oui").on('click', function(e){
      $("#affiche_si_accompagnateur").show();
      $("#affiche_si_pas_accompagnateur").hide();
    });


    $("#modif_acc_2").on('click', function(e){
      $("#affiche_si_accompagnateur").show();
    });
    $("#modif_acc_1").on('click', function(e){
      $("#affiche_si_accompagnateur").hide();
    });
    $("#modif_acc_3").on('click', function(e){
      $("#affiche_si_accompagnateur").hide();
    });

    $("#has_acc_Non").on('click', function(e){
      e.preventDefault();
      $("#affiche_si_accompagnateur").hide();
      $("#affiche_si_pas_accompagnateur").show();
    });

    $(".ajouter_acc").on('click', function(e){
      e.preventDefault();
      $("#recuperation_acc").html("");
      $.ajax({
            url: 'inc/xhr/actions.php?action=ajouter_acc',
            success: function(data) {
                $("#creation_acc").html(data);
            }
        })
    });




    $("#souhaite_acc_Non").on('click', function(e){
      $("#choisir_acc").html("");
    });


    $(".recuper_acc").on('click', function(e){
      e.preventDefault();
      $("#creation_acc").html("");
      $.ajax({
            url: 'inc/xhr/actions.php?action=chercher_acc',
            success: function(data) {
                $("#recuperation_acc").html(data);
            }
        })
    });

    $("#recuperation_acc").on('click', "#acc_chercher", function(e){
      e.preventDefault();
      // console.log('ici');
      nom = $("#acc_nom").val();
      cp = $("#acc_cp").val();
      if(nom == '' || cp == '')
        alert("vous devez renseigner les deux champs de recherche");
      else {
        $.ajax({
              url: 'inc/xhr/actions.php?action=recuperer_acc&nom='+nom+'&cp='+cp,
              success: function(data) {
                // console.log(data);
                  $("#recuperation_acc").html(data);
              }
          })
      }
    });

    // accompagnateur 2


    $("#has_acc2_Oui").on('click', function(e){
      $("#affiche_si_accompagnateur2").show();
      $("#affiche_si_pas_accompagnateur2").hide();
    });


    $("#modif_acc2_2").on('click', function(e){
      // console.log("ho");
      $("#affiche_si_accompagnateur2").show();
    });
    $("#modif_acc2_1").on('click', function(e){
      $("#affiche_si_accompagnateur2").hide();
    });
    $("#modif_acc2_3").on('click', function(e){
      $("#affiche_si_accompagnateur2").hide();
    });

    $("#has_acc2_Non").on('click', function(e){
      e.preventDefault();
      $("#affiche_si_accompagnateur2").hide();
      $("#affiche_si_pas_accompagnateur2").show();
    });

    $(".ajouter_acc2").on('click', function(e){
      e.preventDefault();
      $("#recuperation_acc2").html("");
      $.ajax({
            url: 'inc/xhr/actions.php?action=ajouter_acc&indice=2',
            success: function(data) {
                $("#creation_acc2").html(data);
            }
        })
    });



    $("#souhaite_acc2_Oui").on('click', function(e){
      cp = $("#cp").val();
      if(cp=="") {
        alert('vous devez renseigner votre adresse (code postal) avant de pouvoir trouver un accompagnateur')
      } else {
        acc1 = $(".form-acc").data('idacc');
        $("#choisir_acc2").html("");
        $.ajax({
              url: 'inc/xhr/actions.php?action=choisir_acc&indice=2&cp='+cp+'&deja='+acc1,
              success: function(data) {
                  $("#choisir_acc2").html(data);
              }
          })
      }
    });
    $("#souhaite_acc2_Non").on('click', function(e){
      $("#choisir_acc2").html("");
    });


    $(".recuper_acc2").on('click', function(e){
      e.preventDefault();
      $("#creation_acc2").html("");
      $.ajax({
            url: 'inc/xhr/actions.php?action=chercher_acc&indice=2',
            success: function(data) {
                $("#recuperation_acc2").html(data);
            }
        })
    });

    $("#recuperation_acc2").on('click', "#acc_chercher2", function(e){
      e.preventDefault();
      // console.log('ici');
      nom = $("#acc_nom").val();
      cp = $("#acc_cp").val();
      if(nom == '' || cp == '')
        alert("vous devez renseigner les deux champs de recherche");
      else {
        $.ajax({
              url: 'inc/xhr/actions.php?action=recuperer_acc&nom='+nom+'&cp='+cp+'&indice=2',
              success: function(data) {
                // console.log(data);
                  $("#recuperation_acc2").html(data);
              }
          })
      }
    });


    $(".liste_fiches").on('click', ".suppr-fiche", function(e){
      if(confirm("Voulez-vous supprimer cette fiche ?"))
          $("#"+$(this).data("target")).parents(".fiche").remove();
    });


    $('<div class="modal" tabindex="1">').appendTo('body');
    var modal = $('.modal');
    $('.modal').on('click', function(){
        close_all();
    });

    var hamburger = $('#menu-toggle');
    var menu = $(hamburger.data('target'));
    hamburger.click(function(e) {
        e.preventDefault();
        modal.toggle();
        hamburger.toggleClass('active');
        menu.toggleClass('open');
        menu.find('.current').addClass('open').siblings().removeClass('open');
        // window.scrollTo(0,0);
    });

    $('.nav1 .menu_link').on('click', function(e){
        e.preventDefault();
        $(this).parents('.menu_item').toggleClass('open').siblings().removeClass('open');
    })

    // $('.nav1 .menu_item').on('mouseover', function(){
    //     $(this).addClass('hover').siblings().removeClass('hover open');
    // });
    // $('.nav1 .menu_item').on('mouseout', function(){
    //     $(this).removeClass('hover open');
    // });

    $('.panel').hide();
    $('.panel.first').show();

    $('a[role="tab"]').on('click', function(e){
        e.preventDefault();
        mon_parent = $(this).parents('[role="tablist"]');
        mes_tabs = mon_parent.find('a[role="tab"]');
        mes_panneaux = mon_parent.siblings('[role="panel"]');

        target = $(this).attr('aria-controls');

        mes_tabs.attr("aria-selected", "false");
        $(this).attr("aria-selected", "true");

        mes_panneaux.hide();
        $('#'+target).show();
    });


    function close_all() {
        modal.hide();
        menu.removeClass('open');
        hamburger.removeClass('active');
    }

    $("body").on('change', ".fileinput", function(e){
      var $input   = $( this ),
          $label   = $input.next( '.filelabel' ),
          labelVal = $label.html();

      var fileName = '';
      if( e.target.value )
          fileName = e.target.value.split( '\\' ).pop();
      if( fileName )
          $label.html( fileName );
      else
          $label.html( labelVal );

      $input
          .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
          .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
    });


    let siteheader = $("#site-header");
    if (siteheader.length){
      $("#site-header").stickybits({
          useStickyClasses: true
      });

      $("#site-header")[0].style.setProperty("--barreH", "-"+$(".barremenu").outerHeight()+'px');

      $(window).on('resize', function(){
        $("#site-header")[0].style.setProperty("--barreH", "-"+$(".barremenu").outerHeight()+'px');
      });

      let c, currentScrollTop = 0;
      $(window).scroll(function () {
          let a = $(window).scrollTop();
          let b = siteheader.outerHeight();

          currentScrollTop = a;

          if (c < currentScrollTop && a > b + b) {
              siteheader.addClass("scrollUp");
          } else if (c > currentScrollTop && !(a <= b)) {
              siteheader.removeClass("scrollUp");
          }
          c = currentScrollTop;
      });
    }

    // $("#action-bottom").stickybits({
    //     verticalPosition: 'bottom',
    //     useStickyClasses: true
    // });

}); // document.ready
})(jQuery);



function fermer_popin(){
    $("#popin .container").html("");
    $("#popin").hide();
    $("#contpopinnoir").html("");
    $("#popinnoir").hide();
    $("#minipopin .container").html("");
    $("#minipopin").hide();
}

function ouvre_popin(data){
    // var popin_content = "<div style=\"float:right\"><a class=\"bouton2\" href=\"javascript:fermer_popin()\">X</a></div><div style=\"clear:both; \"> " + data + "</div>";
    // $("#popin .container").html(popin_content); // ON AFFICHE LA REPONSE
    $("#popin .container").html(data); // ON AFFICHE LA REPONSE
    $("#popin").show();

    // var left = ($(window).width() - $("#popin").width())/2;
    var posScroll = parseInt($(document).scrollTop());

    $("#popin").css('top',(posScroll+150)+'px');

    $('.tableauborder tbody').each(function(){
        $('tr:has(td):odd', this).addClass('trgris');
    });
}




function select_correspondant(type) {
  id = $("#correspondant_id_"+type).val();
  $.ajax({
            url: 'inc/xhr/actions.php?action=set_correspondant_ja&id_correspondant='+id+'&type='+type,
            success: function(data) {
              //console.log(data);
              location.reload();
            }
        })

}

function select_mandataire(i) {
  id = $("#mandataire_"+i).val();
  autre = (i==1) ? 2 : 1;
  $("#mandataire_"+autre+" option").attr("disabled",null);
  $("#mandataire_"+autre+" option[value=\""+id+"\"").attr("disabled","disabled");
  if($("#mandataire_1").val()==$("#mandataire_2").val()) {
    alert("Les deux mandataires doivent être deux membres différent·e·s !")
    return false;
  }
  else {
    $.ajax({
              url: 'inc/xhr/actions.php?action=set_mandataire&id_membre='+id+'&num='+i,
              success: function(data) {
                //location.reload();
              }
          })
  }

}

$('.valider_nouveaux_mandataires').on( 'click', function(e) {
        e.preventDefault();
        id=$(this).data('idcpt');
        if (confirm('Valider les nouveaux·elles mandataires ?')){
            $.ajax({url: 'inc/xhr/actions.php?action=valider_nouveaux_mandataires&id='+id,
                    success: function(data) {
                            window.location.reload();
                        }
                    })
        }
    });


function select_futur_mandataire(i) {
  id = $("#futur_mandataire_"+i).val();
  autre = (i==1) ? 2 : 1;
  $("#futur_mandataire_"+autre+" option").attr("disabled",null);
  if(id!='')
  $("#futur_mandataire_"+autre+" option[value=\""+id+"\"").attr("disabled","disabled");
  if($("#futur_mandataire_1").val()==$("#futur_mandataire_2").val() && $("#futur_mandataire_2").val()!='') {
    alert("Les deux futur·e·s mandataires doivent être deux membres différent·e·s !")
    return false;
  }
  else {
    $.ajax({
              url: 'inc/xhr/actions.php?action=set_futur_mandataire&id_membre='+id+'&num='+i,
              success: function(data) {
                // console.log(data);
                //location.reload();
              }
          })
  }

}

function action_selection() {
  var action = $("#actionselection").val();

  if(action=="exporter_adresses_JA_excel") {
    window.open('export_xls/export_adresses_JA.php?format=xls');
  }
  if(action=="exporter_adresses_JA_csv") {
    window.open('export_xls/export_adresses_JA.php?format=csv');
  }
  if(action=="exporter_excel") {
    window.open('export_xls/export_liste.php?format=xls');
  }
  if(action=="exporter_csv") {
    window.open('export_xls/export_liste.php?format=csv');
  }
  if(action=="exporter_membres_pdf") {
    window.open('export_pdf/export_membres.php');
  }
  if(action=="exporter_liste_assurance") {
    window.open('export_xls/export_assurance.php');
  }
  if(action=="exporter_remise_cheque") {
    window.open('export_xls/export_remise_cheque.php?format=xls');
  }
  if(action=="rassembler-doublons-al") {
    $.ajax({
        url: 'inc/xhr/actions.php?action=rassembler_doublons_al',
        success: function(data) {
          ouvre_popin(data);
        }
    });
  }
  if(action=="supprimer_ja") {
    if(confirm('êtes-vous sûr(e) de vouloir supprimer ces JA ?')) {
      $.ajax({
        url: 'inc/xhr/actions.php?action=supprimer_ja',
        success: function(data) {
          location.reload();
        }
      });
    }
  }
  if(action=="envoyer_mail") {
    $.ajax({
        url: 'inc/xhr/actions.php?action=envoyer_mail',
        success: function(data) {
          ouvre_popin(data);
        }
    });
  }
  if(action=="envoyer_sms") {
    $.ajax({
        url: 'inc/xhr/actions.php?action=envoyer_sms',
        success: function(data) {
          ouvre_popin(data);
        }
    });
  }
  if(action=="cloturer_comptes") {
    $.ajax({
        url: 'inc/xhr/actions.php?action=cloturer_comptes',
        success: function(data) {
          ouvre_popin(data);
        }
    });
  }
}

function check_select_table(tablename) {
    $table = $("#"+tablename);
    classtoadd = "tous";
    classtoremove = "selection";
    if ( $("#"+tablename+" .cocheselection:checked").length >0 ){
        classtoadd = "selection";
        classtoremove = "tous";
    };
    $('.detail-' + classtoremove).hide();
    $('.detail-' + classtoremove).prop( "disabled", true );
    $('.detail-' + classtoadd).show();
    $('.detail-' + classtoadd).prop( "disabled", false );
}

function go_to_url(url) {
  window.location.href=url;
}


function save_after_save(table, value) {
  $.ajax({
        url: 'inc/xhr/actions.php?action=save_after_save&table='+table+'&value='+value,
        success: function(data) {
          //console.log(data);
        }
    });
}

// (function(){

//   function removeAccents ( data ) {
//       if ( data.normalize ) {
//         // Use I18n API if avaiable to split characters and accents, then remove
//         // the accents wholesale. Note that we use the original data as well as
//         // the new to allow for searching of either form.
//         return data +' '+ data
//           .normalize('NFD')
//           .replace(/[\u0300-\u036f]/g, '');
//       }

//       return data;
//   }

//   if (typeof jQuery.fn.DataTable != undefined) {
//     var searchType = jQuery.fn.DataTable.ext.type.search;

//     searchType.string = function ( data ) {
//       return ! data ?
//           '' : typeof data === 'string' ?
//           removeAccents( data ) :
//           data;
//     };

//     searchType.html = function ( data ) {
//       return ! data ?
//         '' : typeof data === 'string' ?
//         removeAccents( data.replace( /<.*?>/g, '' ) ) :
//         data;
//     };
//   }

// }());
